module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"views":{"privacy_policy":{"meta_tags":{"description":"Thank you for your interest in CAPinside and for visiting our website. At this point we would like to inform you which of your personal data we collect when you visit our website and for what purposes it is used.","title":"Privacy Policy"}}}}}}')
  delete Component.options._Ctor
}
